import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { salesOrdersPageDef } from '@/components/scm/scm-page-defs';

export default function ScmSalesOrdersPage() {
  return <ScmPageRenderer pageDef={salesOrdersPageDef} />;
}
